// each report template is fixed, list all posibilities
enum ReportTemplate {
  TELEOPHTH = 'teleophth_small',
}

export enum ReportTemplateNameEnum {
  TELEOPHTH = 'Teleophthalmology',
}

const ReportTemplateName = (template: ReportTemplate): string => {
  if (template === ReportTemplate.TELEOPHTH) {
    return ReportTemplateNameEnum.TELEOPHTH;
  } else {
    return `Unknown template: ${template}`;
  }
};

export { ReportTemplate, ReportTemplateName };
